window.addEventListener("DOMContentLoaded", (event) => {
    var myOffcanvas = document.getElementById('offcanvasInfo');
    myOffcanvas.addEventListener('show.bs.offcanvas', function () {
        var elements = document.getElementsByClassName('hamburger');
        for (var i = 0; i < elements.length; i++) {
            elements[i].classList.add("opened");
        }
    });
});
window.addEventListener("DOMContentLoaded", (event) => {
    var myOffcanvas = document.getElementById('offcanvasInfo');
    myOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
        var elements = document.getElementsByClassName('hamburger');
        for (var i = 0; i < elements.length; i++) {
            elements[i].classList.remove("opened");
        }
    });
});

window.addEventListener("DOMContentLoaded", (event) => {
    var myOffcanvasMenuMain = document.getElementById('offcanvasMenuMain');
    myOffcanvasMenuMain.addEventListener('show.bs.offcanvas', function () {
        var elements = document.getElementsByClassName('hamburger');
        for (var i = 0; i < elements.length; i++) {
            elements[i].classList.add("opened");
        }
    });
});
window.addEventListener("DOMContentLoaded", (event) => {
    var myOffcanvasMenuMain = document.getElementById('offcanvasMenuMain');
    myOffcanvasMenuMain.addEventListener('hidden.bs.offcanvas', function () {
        var elements = document.getElementsByClassName('hamburger');
        for (var i = 0; i < elements.length; i++) {
            elements[i].classList.remove("opened");
        }
    });
});


window.addEventListener("DOMContentLoaded", function () {
    if (window.blogMenuAlwaysOpened) {
        // Seleziona solo gli hamburger dentro .blog-hamburger
        var elements = document.querySelectorAll('.blog-hamburger .hamburger');
        for (var i = 0; i < elements.length; i++) {
            elements[i].classList.add("opened");
        }
        var offcanvas = document.getElementById('blogSidebarOffcanvas');
        if (offcanvas) {
            offcanvas.addEventListener('hidden.bs.offcanvas', function () {
                for (var i = 0; i < elements.length; i++) {
                    elements[i].classList.add("opened");
                }
            });
            offcanvas.addEventListener('show.bs.offcanvas', function () {
                for (var i = 0; i < elements.length; i++) {
                    elements[i].classList.add("opened");
                }
            });
        }
    }
});